export default "__VITE_ASSET__CQP3X9cf__"